import axios from 'axios'
import '@/api'
import { extract } from './utils'
import { merge } from 'lodash'
import moment from 'moment'

// ------------------------------------
// Endpoint Configuration
// ------------------------------------

const endpointConfig = {
  url: '/users'
}

// ------------------------------------
// Initial State
// ------------------------------------

const state = {
  user: {},
  users: []
}

// ------------------------------------
// Getters
// ------------------------------------

const getters = {
  user: state => state.user,
  users: state => state.users
}

// ------------------------------------
// Constants
// ------------------------------------

const REQUEST_GET_USER = 'REQUEST_GET_USER'
const RECEIVE_GET_USER = 'RECEIVE_GET_USER'

const REQUEST_CREATE_USER = 'REQUEST_CREATE_USER'
const RECEIVE_CREATE_USER = 'RECEIVE_CREATE_USER'

const REQUEST_UPDATE_USER = 'REQUEST_UPDATE_USER'
const RECEIVE_UPDATE_USER = 'RECEIVE_UPDATE_USER'

const REQUEST_DELETE_USER = 'REQUEST_DELETE_USER'
const RECEIVE_DELETE_USER = 'RECEIVE_DELETE_USER'

const UPDATE_USER_PROPERTY = 'UPDATE_USER_PROPERTY'

const REQUEST_GET_USERS = 'REQUEST_GET_USERS'
const RECEIVE_GET_USERS = 'RECEIVE_GET_USERS'

// ------------------------------------
// Actions
// ------------------------------------

const actions = {
  async getUsers ({ commit, dispatch }, { includes = undefined, filters = undefined, sort = undefined }) {
    dispatch('wait/start', 'getting users', { root: true })
    commit(REQUEST_GET_USERS)
    const config = merge({}, endpointConfig, { params: merge({}, filters, { include: includes }, { sort: sort }) })
    return axios.get(endpointConfig.url, config)
      .then((response) => {
        dispatch('receiveUsers', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting users', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting users', { root: true })
        return Promise.reject(error)
      })
  },
  async getUser ({ commit, dispatch }, { id, includes = undefined }) {
    dispatch('wait/start', 'getting user', { root: true })
    commit(REQUEST_GET_USER, id)
    const config = merge({}, endpointConfig, { params: { include: includes } })
    return axios.get(`${endpointConfig.url}/${id}`, config)
      .then((response) => {
        dispatch('receiveUser', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting user', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting user', { root: true })
        return Promise.reject(error)
      })
  },
  // async createUser ({ commit, dispatch }, { data, includes = undefined }) {
  //   console.log(data, includes)
  //   dispatch('wait/start', 'creating user', { root: true })
  //   commit(REQUEST_CREATE_USER, data)
  //   const config = merge({}, endpointConfig, { params: { include: includes } })
  //   return axios.post(`${endpointConfig.url}`, data, config)
  //     .then((response) => {
  //       dispatch('receiveUser', [ response.data, 'CREATE' ])
  //       dispatch('wait/end', 'creating user', { root: true })
  //       return Promise.resolve(true)
  //     })
  //     .catch((error) => {
  //       dispatch('wait/end', 'creating user', { root: true })
  //       return Promise.reject(error)
  //     })
  // },
  async updateUser ({ commit, dispatch }, { id, data, includes = undefined }) {
    dispatch('wait/start', 'updating user', { root: true })
    commit(REQUEST_UPDATE_USER, id)
    const config = merge({}, endpointConfig, { params: { include: includes } })
    return axios.put(`${endpointConfig.url}/${id}`, data, config)
      .then((response) => {
        dispatch('receiveUser', [ response.data, 'UPDATE' ])
        dispatch('wait/end', 'updating user', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'updating user', { root: true })
        return Promise.reject(error)
      })
  },
  // async deleteUser ({ commit, dispatch }, id) {
  //   dispatch('wait/start', 'deleting user', { root: true })
  //   commit(REQUEST_DELETE_USER, id)
  //   return axios.delete(`${endpointConfig.url}/${id}`, endpointConfig)
  //     .then((response) => {
  //       commit(RECEIVE_DELETE_USER, response.data)
  //       dispatch('wait/end', 'deleting user', { root: true })
  //       return Promise.resolve(true)
  //     })
  //     .catch((error) => {
  //       dispatch('wait/end', 'deleting user', { root: true })
  //       return Promise.reject(error)
  //     })
  // },
  receiveUser ({ commit }, [ json, action ]) {
    commit(`RECEIVE_${action}_USER`, extract(json))
    return json.data
  },
  receiveUsers ({ commit }, [ json, action ]) {
    commit(`RECEIVE_${action}_USERS`, extract(json))
    return json.data
  },
  updateUserProperty ({ commit }, [ property, value ]) {
    commit(`UPDATE_USER_PROPERTY`, [ property, value ])
  }
}

// ------------------------------------
// Mutations
// ------------------------------------

const mutations = {
  [REQUEST_GET_USER] (state, id) {
  },
  [RECEIVE_GET_USER] (state, json) {
    state.user = json
  },
  [REQUEST_CREATE_USER] (state, json) {
  },
  [RECEIVE_CREATE_USER] (state, json) {
    state.user = json
  },
  [REQUEST_UPDATE_USER] (state, id) {
  },
  [RECEIVE_UPDATE_USER] (state, json) {
    state.user = json
  },
  [REQUEST_DELETE_USER] (state, id) {
  },
  [RECEIVE_DELETE_USER] (state, json) {
    state.user = {}
  },
  [UPDATE_USER_PROPERTY] (state, [ property, value ]) {
    state.user[property] = value
  },
  [REQUEST_GET_USERS] (state) {
  },
  [RECEIVE_GET_USERS] (state, json) {
    state.users = json
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
